import { useState } from "react";
import { auth, reminderAPI } from "services";
import useUniversalStore from "store/universalStore";
import { sendWAReminder } from "utils";

const ReminderAlert = (props) => {
  const { account, closeReminderAlert } = props;
  const profile = useUniversalStore(state => state.profile);

  const sendReminder = async () => {
    sendWAReminder(account, profile.get("businessName"));
  };

  return (
    <div className="row position-fixed bottom-0 start-50 my-5 py-3 px-4 w-auto flex-wrap position-sticky" style={{ bottom: 0 }}>
      <div className="alert bg-white p-4" role="alert" style={{ marginTop: "-200px" }}>
        <div className="text-center">
          <h2>Payment Overdue !!</h2>
          <hr />
        </div>
        <br />
        <div className="d-flex justify-content-center align-items-center">
          <div className="btn btn-secondary me-3 p-3" onClick={closeReminderAlert}>
            Close
          </div>
          <div onClick={sendReminder} className="btn btn-app border-app p-3">
            Send Reminder
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReminderAlert;